/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".block-ui-container{height:100%}.form-header[_ngcontent-%COMP%]{margin:.1em 0;padding:.5em .5em .25em}form[_ngcontent-%COMP%]{padding:.5em;height:1px;overflow:auto}"];
export { styles as styles };
